// extracted by mini-css-extract-plugin
export default {"loader":"loader__8R8O7"};